import { Components } from "@/components";
import { App } from "vue";
import ApexChart from "vue3-apexcharts";
import { autoAnimatePlugin } from "@formkit/auto-animate/vue";
import Draggable from "vuedraggable"

export default function setComponent(app: App): void {
  app.use(ApexChart);
  app.use(autoAnimatePlugin);
  app.component("ApexChart", ApexChart);
  app.component("Errors", Components.Errors());
  app.component("Loader", Components.Loader());
  app.component("Table", Components.TableFilter());
  app.component("Dropzone", Components.Dropzone());
  app.component("CardCourseComponent", Components.CardCourse());
  app.component("CardView", Components.Card());
  app.component("Topbar", Components.Topbar());
  app.component("BreadcrumbComponent", Components.Breadcrumb());
  app.component("EmptyData", Components.EmptyData());
  app.component("Logo", Components.Logo());
  app.component("VideoComponent", Components.Video());
  app.component("PDFComponent", Components.PDFComponent());
  app.component("TopbarCourse", Components.TopbarCourse());
  app.component("MaterialLoad", Components.MaterialLoad());
  app.component("FooterComponent", Components.Footer());
  app.component("Banner", Components.Banner());
  app.component("CountDown", Components.CountDown());
  app.component("MessageVoice", Components.MessageVoice());
  app.component("SpeechRecognition", Components.Speech());
  app.component("RecordStream", Components.Record());
  app.component("Attention", Components.Attention());
  app.component("LearningMapTeacher", Components.LearningMapTeacher());
  app.component("LearningMap", Components.LearningMap());
  app.component("InfiniteScroll", Components.InfiniteScroll());
  app.component("TagMaterials", Components.TagMaterials());
  app.component("ModalPermissionBrowser", Components.ModalPermissionBrowser());
  app.component("LimitTimeModal", Components.LimitTimeModal());
  app.component("MaterialModal", Components.MaterialModal());
  app.component(
    "CourseLearningMapStudent",
    Components.CourseLearningMapStudent()
  );
  app.component("FullModal", Components.FullModal());
  app.component("ImportCSV", Components.ImportCSV());
  app.component("ListObjective", Components.ListObjective());
  app.component("ProgressCircleMaterial", Components.ProgressCircleMaterial());
  app.component("OrderButtons", Components.OrderButtons());
  app.component("Draggable", Draggable);
}
